module.exports = __webpack_public_path__ + "img/email_action_reply.d08ef903.svg";